import React from "react";
import { Col, Row } from "antd";
import { Controller } from "react-hook-form";
import CustomTextfield from "../../../../../../common/input/custom-textfield/custom-textfield";
import { MailOutlined, PhoneOutlined } from "@ant-design/icons";

const TeacherContactInformation = ({ control }) => (
  <Row gutter={[32, 20]}>
    <Col span={12}>
      <Controller
        name="phone_number"
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <CustomTextfield
            id="phone_number"
            label="Phone Number"
            showRequired
            labelColor="#171717"
            placeholder="Enter phone number"
            size="large"
            value={value}
            prefix={
              <PhoneOutlined style={{ color: "#999999", paddingRight: 4 }} />
            }
            onChange={onChange}
            status={error ? "error" : ""}
          />
        )}
      />
    </Col>

    <Col span={12}>
      <Controller
        name="email"
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <CustomTextfield
            id="email"
            label="Email"
            showOptional
            type="email"
            labelColor="#171717"
            placeholder="Enter email address"
            size="large"
            value={value}
            prefix={
              <MailOutlined style={{ color: "#999999", paddingRight: 4 }} />
            }
            onChange={onChange}
            status={error ? "error" : ""}
          />
        )}
      />
    </Col>
  </Row>
);

export default TeacherContactInformation;
